import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CampanhaROIKPI, getROIKPI } from '../../../campanha-roi-kpi';

@Component({
    selector: 'sgt-campanha-roi-widget-roi',
    templateUrl: './campanha-roi-widget-roi.component.html',
    styleUrls: ['./campanha-roi-widget-roi.component.less']
})
export class CampanhaROIWidgetROIComponent implements OnChanges {
    KPI: CampanhaROIKPI;

    @Input() isLoading: boolean;
    @Input() roi = 0;

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'roi') {
                this.KPI = getROIKPI(this.roi);
            }
        }
    }
}
